import pdfMake from 'addthaifont-pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import _ from 'lodash';
import { Content } from 'antd/es/layout/layout';
import { footer } from './common';
import { log } from 'addthaifont-pdfmake/build/pdfmake';

dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

// 🔧 สร้างตารางรายการสินค้า
// 🔧 สร้างตารางรายการสินค้า (รวมหัวตาราง)
const genBody = (orders) => {
    // เพิ่มหัวตารางเป็นแถวแรก
    const headerRow = [
        {
            text: "ลำดับ",
            bold: true,
            alignment: "center",
            margin: [0, 4, 0, 4],
            fillColor: '#f0f0f0', // สีพื้นหลังหัวตาราง
            fontSize: 12
        },
        {
            text: "รายการสินค้า",
            bold: true,
            alignment: "center",
            margin: [0, 4, 0, 4],
            fillColor: '#f0f0f0',
            fontSize: 12
        },
        {
            text: "คลังสินค้า",
            bold: true,
            alignment: "center",
            margin: [0, 4, 0, 4],
            fillColor: '#f0f0f0',
            fontSize: 12
        },
        {
            text: "จำนวน",
            bold: true,
            alignment: "center",
            margin: [0, 4, 0, 4],
            fillColor: '#f0f0f0',
            fontSize: 12
        }
    ];

    let index = 1;
    const dataRows = _.compact(_.map(orders, (order) => {
        const product = order?.product;
        if (!product) return null;

        return [
            {
                text: index++,
                alignment: 'center',
                fontSize: 10,
                margin: [0, 2, 0, 2],
                border: [true, true, true, true] // เพิ่มตรงนี้
            },
            {
                text: `${product?.model_name?.trim() || ''} ${product?.name?.trim() || ''}`.trim(),
                fontSize: 10,
                alignment: 'left',
                margin: [0, 2, 0, 2],
                border: [true, true, true, true] // เพิ่ม border
            },
            {
                text: order?.warehouse?.name || '',
                fontSize: 10,
                alignment: 'center',
                margin: [0, 2, 0, 2],
                border: [true, true, true, true] // เพิ่ม border
            },
            {
                text: `${order.amount || 0} ${product?.unit || ''}`,
                fontSize: 10,
                alignment: 'center',
                margin: [0, 2, 0, 2],
                border: [true, true, true, true] // เพิ่ม border
            }
        ];
    }));

    const MIN_ROWS = 18;
    // หมายเหตุ: กำหนดจำนวนแถวขั้นต่ำในตารางสินค้า หากข้อมูลน้อยกว่าจะเติมแถวว่างให้ครบ
    while (dataRows.length < MIN_ROWS) {
        dataRows.push([
            { text: '', alignment: 'center', margin: [0, 6, 0, 6], border: [false, false, false, false] },
            { text: '', alignment: 'center', margin: [0, 6, 0, 6], border: [false, false, false, false] },
            { text: '', alignment: 'center', margin: [0, 6, 0, 6], border: [false, false, false, false] },
            { text: '', alignment: 'center', margin: [0, 6, 0, 6], border: [false, false, false, false] }
        ]);
    }

    return [
        headerRow,
        ...dataRows
    ];
};

const orderReturn = async (productTransaction, setting) => {
    const fromWarehouse = productTransaction?.orders?.[0]?.warehouse?.name || 'ไม่ระบุ';
    const toWarehouse = 'คลังงานโครงการ';
    const docNumber = `EP${productTransaction?.running_number_return || '-'}`;
    const docDate = dayjs(productTransaction?.export_date).format('DD/MM/BB');
    const requester =
        productTransaction?.import_employee
            ?.firstname || productTransaction?.import_employee
                ?.lastname
            ? `${productTransaction?.import_employee
                ?.firstname || ''} ${productTransaction?.import_employee
                    ?.lastname || ''}`.trim()
            : '';
    const genItemBody = genBody(productTransaction?.orders || []);
    console.log("genItemBody", genItemBody);

    const warehouseNames = productTransaction?.warehouse_status
        ?.filter(w => w.status === true)
        ?.map(w => w?.warehouse_name)
        .join(', ');
    const documentRef = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins: [20, 140, 40, 80], // ลดส่วนบนลงเพราะไม่มีหัวตารางใน header แล้ว
        defaultStyle: {
            font: 'Sarabun',
            fontSize: 10,
        },
        header: [
            {
                margin: [20, 20, 20, 20],
                table: {
                    widths: ['*', '45%'],
                    body: [
                        [
                            {
                                text: "บริษัท วี ทู เอส เอ็นจิเนียริ่ง จำกัด",
                                style: 'bodyHeader',
                                fontSize: 14,
                                border: [false, false, false, false],
                            },
                            {
                                text: "",
                                border: [false, false, false, false],
                                style: 'header',
                            },
                        ],
                        [
                            {
                                text: '',
                                border: [false, false, false, false],
                            },
                            {
                                text: "ใบรับคืนสินค้า",
                                alignment: 'right',
                                fontSize: 14,
                                style: 'header',
                                border: [false, false, false, false],
                            },
                        ],
                        [
                            { text: `หมายเลขโครงการ: ${productTransaction?.project_number} `, fontSize: 12, border: [false, false, false, false] },
                            { text: `หมายเลขเอกสาร  ${docNumber} `, fontSize: 12, border: [false, false, false, false] },
                        ],
                        [
                            { text: `เข้าคลัง: ${warehouseNames || '-'} `, fontSize: 12, border: [false, false, false, false] },
                            { text: `วันที่รับคืนสินค้า: ${docDate} `, fontSize: 12, border: [false, false, false, false] },
                        ],
                        [
                            { text: `หมายเลขเอกสารใบส่งออก: ${productTransaction?.product_transaction_export?.running_number} `, fontSize: 12, border: [false, false, false, false] },
                            { text: `พนักงานรับคืน / ผู้รับคืน: ${requester} `, fontSize: 12, border: [false, false, false, false] }
                        ],
                    ],
                },
            }
            // ลบส่วนหัวตารางออกจาก header
        ],
        content: [
            {
                table: {
                    widths: [30, '*', 90, 80],
                    headerRows: 1,
                    dontBreakRows: true,
                    body: genItemBody,
                },
                layout: {
                    hLineWidth: function () { return 1; },
                    vLineWidth: function () { return 1; },
                    hLineColor: function () { return '#000000'; },
                    vLineColor: function () { return '#000000'; },
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: () => 2,
                    paddingBottom: () => 2
                },
                margin: [0, 0, 0, 8]
            },
            {
                text: `หมายเหตุ:  ${productTransaction?.remark} `,
                fontSize: 10,
                margin: [0, 0, 0, 8]
            }
        ],
        footer: {
            margin: [20, 5, 20, 0],
            table: {
                widths: ['*'],
                body: [
                    [
                        { text: 'ผู้จัดทำ ________________________ วันที่ ________/________/________  คลังสินค้า____________________วันที่_______/_______/_______อ้างอิงเอกสาร _______________________', fontSize: 10, border: [false, false, false, false] },
                    ],
                    [
                        { text: 'ผู้คืนสินค้า ______________________________ วันที่ _______________/______________/____________  ผู้อนุมัติ _________________________ วันที่ __________/___________/_________  ', fontSize: 10, border: [false, false, false, false] },
                    ],
                ]
            },
            layout: {
                defaultBorder: false,
                hLineWidth: function (i, node) {
                    // เส้นบนสุดและล่างสุดเท่านั้น
                    if (i === 0 || i === node.table.body.length) return 1;
                    return 0; // ไม่มีเส้นแนวนอนระหว่าง row
                },
                vLineWidth: function (i, node) {
                    return 1; // เส้นคอลัมน์ทุกช่อง
                },
                hLineColor: function () { return '#000000'; },
                vLineColor: function () { return '#000000'; },
                paddingLeft: () => 4,
                paddingRight: () => 4,
                paddingTop: () => 2,
                paddingBottom: () => 2
            }
        },
        styles: {
            headerCompany: {
                fontSize: 13,
                bold: true
            },
            headerTitle: {
                fontSize: 12,
                bold: true
            },
            tableExample: {
                margin: [0, 0, 0, 0]
            }
        }
    };

    pdfMake.createPdf(documentRef).open();
};
export default orderReturn;